import { render, staticRenderFns } from "./BusinessScopeIOT.vue?vue&type=template&id=12910c01&"
import script from "./BusinessScopeIOT.vue?vue&type=script&lang=js&"
export * from "./BusinessScopeIOT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports